import React, { useState, useEffect } from 'react'
import { Toolbar } from 'react-admin'
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'
import Cookies from 'js-cookie'
import SegmentPreview from './SegmentPreview'
import DeactivateSegmentModal from './DeactivateSegmentModal'
import DashboardToolbarProvider from '../../elements/toolbars/DashboardToolbarProvider'
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

interface IProps extends WithStyles {
  ids?: number[],
  data?: ISegment,
  types: ITestTypesList[],
  modules: IModulesList[],
  criterias: ICriteriasList[],
  competences: ICompetencesList[],
  dataProvider: any,
  isArchived?: boolean,
  statusId: number
}

const styles = () => createStyles({
  Toolbar: {
    backgroundColor: '#ffffff',
  },
  checkbox: {
    marginTop: '-88px',
    marginLeft: '10px'
  },
  container: {
    position: 'relative'
  },
  checkboxContainer: {
    position: 'absolute',
    top: -55,
    left: 24
  },
  checkboxAll: {
    marginRight: 24
  }
})

const Segments = withStyles(styles)(({
  classes,
  ids,
  data,
  modules,
  types,
  competences,
  criterias,
  isArchived,
  statusId
}: IProps) => {
  const [checkedValues, setCheckedValues] = useState([])
  const [checkedData, setCheckedData] = useState({})
  const [isCheckAll, setIsCheckAll] = useState(false)

  const [deactivateDisabled, setDeactivateDisabled] = useState(true)
  const role = Cookies.get('role')
  const rolesNotSegmentManagement = ['expertDeveloper', 'expertReviewer', 'editor']

  // при клике на вкладку очищаем все выбранные сегменты
  useEffect(() => {
    setCheckedValues([])
    setCheckedData([])
  }, [data])

  useEffect(() => {
    setDeactivateDisabled(checkedValues.length === 0)
  }, [checkedValues])

  const handleChange = (e, id: never) => {
    if (!checkedValues.includes(id)) {
      setCheckedValues([...checkedValues, id])
    } else {
      setCheckedValues(checkedValues.filter(item => item !== id))
    }
    if (!checkedData[id]) {
      setCheckedData({ ...checkedData, [id]: data[id] })
    } else {
      const newData = checkedData
      delete newData[id]
      setCheckedData({ ...newData })
    }
  }

  /**
   * Выбрать все сегменты.
   */
  const handleSelectAll = () => {
    if (!isCheckAll) {
      setCheckedValues(ids)

      let items = {}
      ids.forEach((el) => {items[el] = data[el]})
      setCheckedData(items)
    } else {
      setCheckedValues([])
      setCheckedData({})
    }

    setIsCheckAll(!isCheckAll)
  }

  return (
      <section className={classes.container}>
        <FormControlLabel
            className={classes.checkboxContainer}
            control={<Checkbox className={classes.checkboxAll} checked={isCheckAll} color="primary" onChange={e => handleSelectAll()}/>}
            label="Выбрать все"
        />
        {ids.map(id => (
            <SegmentPreview
                ids={ids}
                key={id}
                data={data}
                segment={data[id]}
                types={types}
                competences={competences}
                criterias={criterias}
                modules={modules}
                onSegmentCheck={handleChange}
                checkedValues={checkedValues}
                id={id}
                isArchived={isArchived}
                statusId={statusId}
            />
        ))}
        {!isArchived && ids.length > 0 ? (
            <Toolbar className={classes.Toolbar}>
              {!rolesNotSegmentManagement.includes(role) && (<DashboardToolbarProvider segmentsId={checkedValues} checkedData={checkedData} />)}
            </Toolbar>
        ) : ''}
      </section>
  )
})

export default Segments
